import { useState, useEffect } from 'react';

// Scroll-progress targets for each nav link. Each must sit inside the
// "fully visible" range of its overlay in pages/LandingPage.js:
//   lab (About):   fully visible 0.58 – 0.82
//   CTA (Contact): fully visible 0.92 – end
const NAV_TARGETS = {
  home: 0,
  about: 0.70,
  contact: 0.97,
};

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToSection = (key) => {
    const max = document.documentElement.scrollHeight - window.innerHeight;
    window.scrollTo({ top: max * NAV_TARGETS[key], behavior: 'smooth' });
  };

  return (
    <nav
      data-testid="navigation"
      className={`fixed top-0 left-0 right-0 transition-all duration-700 ${
        scrolled
          ? 'bg-black/30 backdrop-blur-md border-b border-white/[0.03]'
          : 'bg-transparent'
      }`}
      style={{ zIndex: 50 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 flex items-center justify-between py-4">
        <button
          onClick={() => scrollToSection('home')}
          data-testid="nav-logo"
          className="focus:outline-none"
        >
          <img
            src="/sansha-logo.png"
            alt="Sansha Labs"
            className="h-5 sm:h-6 w-auto opacity-70 hover:opacity-100 transition-opacity duration-300"
          />
        </button>
        <div className="flex items-center gap-4 sm:gap-8">
          {[
            { key: 'home', label: 'Home' },
            { key: 'about', label: 'About' },
            { key: 'contact', label: 'Contact' },
          ].map((item) => (
            <button
              key={item.key}
              onClick={() => scrollToSection(item.key)}
              data-testid={`nav-${item.label.toLowerCase()}`}
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: '0.75rem',
                fontWeight: 500,
                letterSpacing: '0.06em',
              }}
              className={`text-white/35 hover:text-white/75 transition-colors duration-300 whitespace-nowrap ${
                item.key === 'home' ? 'hidden sm:inline-block' : ''
              }`}
            >
              {item.label}
            </button>
          ))}
          <a
            href="/gtm"
            data-testid="nav-gtm"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: '0.75rem',
              fontWeight: 700,
              letterSpacing: '0.06em',
            }}
            className="whitespace-nowrap rounded-full border border-[rgba(157,76,221,0.55)] bg-[rgba(157,76,221,0.12)] px-3 py-1 text-white/90 hover:text-white hover:border-[rgba(157,76,221,0.9)] transition-colors duration-300"
          >
            GTM Agent
          </a>
        </div>
      </div>
    </nav>
  );
}
